export default __webpack_public_path__ + "static/media/group_1.b0693239.png";